import * as types from '../constants/ActionTypes';
import initialState from './initialState';

export default function(state = initialState.config, action) {
  switch (action.type) {
    case types.SET_PASO:
      return {
        ...state,
        step: action.payload.paso,
      };

    case types.SET_CARGA_PERSONAS:
      return {
        ...state,
        cargaPersonasToggle: action.payload.cargaPersonasToggle,
      };

    case types.SET_CARGA_CONTRAVENTORES:
      return {
        ...state,
        cargarContraventorToggle: action.payload.cargarContraventorToggle,
      };
    case types.SET_VER_PEDIDO_ENVIO:
      return {
        ...state,
        verPedidoEnvio: action.payload.verPedidoEnvio,
      };

    case types.SET_VER_DEPOSITO_CONTRAVENCION:
      return {
        ...state,
        verDepositoContravencion: action.payload.verDepositoContravencion,
      };

    case types.REINICIAR:
      return initialState.config;

    default:
      return state;
  }
}
